'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringFormat = require('string-format');

var _stringFormat2 = _interopRequireDefault(_stringFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (translations, key, locale) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var value = translations[key] && translations[key][locale];
  if (value !== undefined) {
    if (typeof value === 'string') return _stringFormat2.default.apply(undefined, [value].concat(args));
    return value;
  }
  if (args && args.length) return key + '[' + locale + '](' + args.join(', ') + ')';
  return key + '[' + locale + ']';
};